import {useInfiniteQuery} from '@tanstack/react-query';
import {indicatorMatchesFeedback} from './adapters';
import {memberSignalsInfiniteQueryOptions} from './queries';
import type {Indicator} from './types';

// One member's signals for the Member Detail page. Returns the full set plus the
// unreviewed subset (no feedback yet); the API returns the member's whole history
// in a single group, so there's no pagination to flatten beyond that.
export function useMemberSignals(memberId: string): {
  indicators: Indicator[];
  unreviewed: Indicator[];
  unreviewedCount: number;
  isPending: boolean;
  isError: boolean;
  refetch: () => void;
} {
  const query = useInfiniteQuery(memberSignalsInfiniteQueryOptions(memberId));

  const indicators = (query.data?.pages ?? [])
    .flatMap((page) => page.results)
    .flatMap((group) => group.indicators);
  const unreviewed = indicators.filter((indicator) =>
    indicatorMatchesFeedback(indicator, 'pending'),
  );

  return {
    indicators,
    unreviewed,
    unreviewedCount: unreviewed.length,
    isPending: query.isPending,
    isError: query.isError,
    refetch: query.refetch,
  };
}
